<mat-expansion-panel>
  <mat-expansion-panel-header [collapsedHeight]="'35px'" [expandedHeight]="'35px'">
    <mat-panel-title class="text-uppercase">
      Advanced options
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="row">
    <div class="col-12">
      <mat-checkbox [disableRipple]="true" [(ngModel)]="item.IsLead" name="isLead"
        class="light" matTooltip="Continue playing the Lead item until an API trigger is activated">
        Lead item
      </mat-checkbox>
    </div>
  </div>

  <div class="row" *ngIf="fileType === appConst.PDF_FILE_TYPE">
    <div class="col-12">
      <mat-checkbox class="col-6 p-0 light pdf-checkbox" [disableRipple]="true" [(ngModel)]="item.PdfScrollEnabled"
        (change)="item.SecondsToScrollPdfPage = null" name="PdfScrollEnabled"
        matTooltip="Enable the PDF auto-scroll feature">PDF auto-scroll</mat-checkbox>
      <input class="scroll-delay-input" *ngIf="item.PdfScrollEnabled"
        [(ngModel)]="item.SecondsToScrollPdfPage" type="number"
        [min]="appConst.ZERO_PDF_DELAY_INTERVAL" [max]="appConst.MAX_PDF_DELAY_INTERVAL"
        (input)="onPdfDelayInputChanged(item, $event)" placeholder="0" matTooltip="Delay in seconds">
    </div>

    <div class="col-12">
      <label class="col-6 p-0" for="PdfStartPage">PDF start page</label>
      <input class="scroll-delay-input" type="number" placeholder="0" id="PdfStartPage"
        [(ngModel)]="item.PlaylistItemLinks[0].PdfStartPage" [min]="appConst.MIN_PDF_START_PAGE"
        (input)="onPdfStartPageInputChanged(item, $event)" (focusout)="ensureValidPdfStartPage()">
    </div>
  </div>

  <div class="row align-items-center pr-3" *ngIf="item.IsLocal">
    <label for="itemDuration" class="col-md-7 mb-0" matTooltip="Time spent per page in the PDF file">PDF page time</label>
    <div class="col-md-5 p-0" id="itemDuration">
      <duration-picker [(duration)]="item.PdfPageDuration">
      </duration-picker>
    </div>
  </div>

  <div class="row" *ngIf="item.PlaylistItemType === playlistItemTypes.Url">
    <div class="col-12">
      <mat-checkbox [disableRipple]="true" [(ngModel)]="item.SkipIfNoInternet" name="SkipIfNoInternet"
        class="light" matTooltip="Item will be skipped with no internet connection">
        Skip if there is no Internet connection
      </mat-checkbox>
    </div>
  </div>
</mat-expansion-panel>
